import React from 'react';
import { Instagram as InstagramIcon, Heart, MessageCircle, Camera } from 'lucide-react';
import { companyInfo } from '../mock';

export const Instagram = () => {
  const handleInstagramClick = () => {
    window.open(companyInfo.instagramUrl, '_blank');
  };

  return (
    <section id="instagram" className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-3xl mb-8 shadow-2xl">
            <InstagramIcon className="w-12 h-12 text-gray-900" />
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Folge uns auf Instagram
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Bleib auf dem Laufenden! Schau dir unsere aktuellen Projekte, Einblicke hinter die Kulissen und vieles mehr an.
          </p>

          {/* Instagram Handle */}
          <div className="inline-flex items-center space-x-3 bg-white/20 backdrop-blur-md border border-white/30 px-6 py-3 rounded-full mb-10">
            <Camera className="w-5 h-5 text-white" />
            <span className="text-white font-bold text-lg">{companyInfo.instagram}</span>
          </div>

          {/* Features */}
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl">
              <Camera className="w-8 h-8 text-white mx-auto mb-3" />
              <h3 className="text-white font-bold text-lg mb-2">Aktuelle Projekte</h3>
              <p className="text-white/80">Einblicke in unsere tägliche Arbeit</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl">
              <Heart className="w-8 h-8 text-white mx-auto mb-3" />
              <h3 className="text-white font-bold text-lg mb-2">Vorher-Nachher</h3>
              <p className="text-white/80">Beeindruckende Transformationen</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl">
              <MessageCircle className="w-8 h-8 text-white mx-auto mb-3" />
              <h3 className="text-white font-bold text-lg mb-2">Tipps & Tricks</h3>
              <p className="text-white/80">Expertenwissen für Hausbesitzer</p>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={handleInstagramClick}
            className="inline-flex items-center space-x-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-10 py-5 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-2xl"
          >
            <InstagramIcon className="w-6 h-6" />
            <span>Jetzt folgen</span>
          </button>
        </div>
      </div>
    </section>
  );
};